module.exports = __webpack_public_path__ + "static/media/circle-in-progress.23617afb.svg";